// extracted by mini-css-extract-plugin
module.exports = {"success-container":"style_success-container__KyNX0","success-text":"style_success-text__5yXEN","success-hint":"style_success-hint__LygxL","goback-btn":"style_goback-btn__6jSym"};